define('extensions/knockout/bindings/log', [], () => {
    ko.virtualElements.allowedBindings.log = true;

    ko.bindingHandlers.log = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            _.defer(() => console.log(valueAccessor()));
        }
    };
});